// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
  font-family: "Open Sans";
  font-size: 18px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
}

h3 {
  font-family: "Open Sans";
  font-size: 13px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
}

p {
  margin: 0;
  font-family: "Open Sans";
  font-size: 13px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
}

hr {
  margin: 0;
  text-justify: none;
}

.main-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.general-container {
  margin-right: 20px;
  width: 70mm;
}

.main-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.main-image img {
  max-height: 30mm;
  max-width: 70mm;
}

.general-info-container p {
  text-justify: none;
  text-align: left;
}

.generic-chart {
  display: flex;
  padding: 10px 0 10px 0;
}

.generic-chart-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
}

.generic-chart-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.generic-plot-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px 0 0;
}

.last-chart-year-wrapper {
  display: flex;
  width: 90%;
  flex-direction: row;
  justify-content: space-between;
}

.caption-wrapper p {
  font-size: 11px;
  color: black;
  line-height: 13px;
}

.copyright {
  display: none;
  margin-top: 5px;
}
.copyright img {
  width: 40px;
  margin-right: 5px;
}
.copyright p {
  color: #b7b7b7;
}

.financials-container {
  width: 70mm;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/toolbox/charts/company-profile/company-profile.component.scss"],"names":[],"mappings":"AAAA;EAAK,SAAA;EAAS,wBAAA;EAA0B,eAAA;EAAiB,kBAAA;EAAoB,oBAAA;EAAsB,gBAAA;AAOnG;;AANA;EAAK,wBAAA;EAA0B,eAAA;EAAiB,kBAAA;EAAoB,oBAAA;EAAsB,gBAAA;AAc1F;;AAbA;EAAI,SAAA;EAAS,wBAAA;EAA0B,eAAA;EAAiB,kBAAA;EAAoB,oBAAA;EAAsB,gBAAA;AAsBlG;;AArBA;EAAI,SAAA;EAAU,kBAAA;AA0Bd;;AAxBA;EAEI,aAAA;EAIA,aAAA;EACA,sBAAA;AAuBJ;;AApBA;EACI,kBAAA;EACA,WAAA;AAuBJ;;AAnBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAsBJ;AApBI;EAEI,gBAAA;EACA,eAAA;AAqBR;;AAhBI;EACI,kBAAA;EACA,gBAAA;AAmBR;;AAfA;EACI,aAAA;EACA,sBAAA;AAkBJ;;AAfA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAkBJ;;AAdA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAiBJ;;AAbA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAgBJ;;AAZA;EACI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;AAeJ;;AAXI;EACI,eAAA;EACA,YAAA;EACA,iBAAA;AAcR;;AAVA;EACI,aAAA;EACA,eAAA;AAaJ;AAXI;EACI,WAAA;EACA,iBAAA;AAaR;AAXI;EACI,cAAA;AAaR;;AATA;EACI,WAAA;AAYJ","sourcesContent":["h1 { margin:0;font-family: \"Open Sans\"; font-size: 18px; font-style: normal; font-variant: normal; font-weight: 700; } \nh3 { font-family: \"Open Sans\"; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 700;  } \np { margin:0;font-family: \"Open Sans\"; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400;  } \nhr{ margin:0; text-justify: none;}\n\n.main-container {\n    //margin-top:100px;\n    padding:10px;\n    \n    \n    \n    display:flex;\n    flex-direction: column;\n}\n\n.general-container {\n    margin-right:20px;\n    width:70mm;\n    \n}\n\n.main-image {\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    width:100%;\n\n    img {\n        \n        max-height: 30mm;\n        max-width:70mm;\n    }\n}\n\n.general-info-container {\n    p {\n        text-justify:none;\n        text-align:left;\n    }\n}\n\n.generic-chart {\n    display:flex;\n    padding: 10px 0 10px 0;\n}\n\n.generic-chart-header {\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    width:100px;\n    \n}\n\n.generic-chart-text {\n    display:flex;\n    flex-direction:column;\n    align-items: center;\n    justify-content: space-around;\n    \n}\n\n.generic-plot-wrapper {\n    display:flex;\n    flex-direction: column;\n    align-items:center;\n    justify-content: center;\n    padding: 0 10px 0 0;\n    \n}\n\n.last-chart-year-wrapper {\n    display:flex;\n    width:90%;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.caption-wrapper {\n    p {\n        font-size:11px;\n        color:black;\n        line-height: 13px;\n    }\n}\n\n.copyright {\n    display:none;\n    margin-top:5px;\n\n    img {\n        width:40px;\n        margin-right: 5px;\n    }\n    p {\n        color:#b7b7b7;\n    }\n}\n\n.financials-container {\n    width:70mm;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
